import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";


class SubItem3 extends Component {
    state = {  }
    render() { 
        return (
            <div id = "item3">
                <Row style={{backgroundColor: "fff", paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <Col md={4}>
                        
                    </Col>
                    <Col md={8}>
                        <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">Perfil del egresado</div>
                        <div align="justify" style={{fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                            El Diseñador de Moda formado en nuestra institución es un profesional integral con capacidades para aplicar conceptos estéticos en la creación de indumentaria, complementos y accesorios desde la investigación y la innovación de tendencias, con un amplio criterio de calidad en la producción, ética social y conciencia ambiental, preparado para producir y gerenciar productos y marcas en la Industria de la Moda. 
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default SubItem3;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoModa/SubItem3.jsx